import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en'
  }
});

class ApiClient {
  static get(url, params, customConfigs) {
    return client.get(url, { params, ...customConfigs });
  }
  static post(url, data, customConfigs) {
    return client.post(url, data, customConfigs);
  }
}

export default ApiClient;
